import * as ACTION_TYPES from "../actions/action_types";

export const initialState = {
  account: "NoAccount",
};

export const SelectedAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SELECTEDACCOUNT:
      return {
        ...state,
        account: action.payload,
      };
    case ACTION_TYPES.FAILURE:
      return {
        ...state,
        account: "FAILURE",
      };
    default:
      return state;
  }
};
